/* tag : v1.0.1 */
!(function (t, e) {
  if ("object" == typeof exports && "object" == typeof module)
    module.exports = e();
  else if ("function" == typeof define && define.amd) define([], e);
  else {
    var i = e();
    for (var o in i) ("object" == typeof exports ? exports : t)[o] = i[o];
  }
})(window, function () {
  return (function (t) {
    var e = {};
    function i(o) {
      if (e[o]) return e[o].exports;
      var n = (e[o] = { i: o, l: !1, exports: {} });
      return t[o].call(n.exports, n, n.exports, i), (n.l = !0), n.exports;
    }
    return (
      (i.m = t),
      (i.c = e),
      (i.d = function (t, e, o) {
        i.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: o });
      }),
      (i.r = function (t) {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(t, "__esModule", { value: !0 });
      }),
      (i.t = function (t, e) {
        if ((1 & e && (t = i(t)), 8 & e)) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var o = Object.create(null);
        if (
          (i.r(o),
          Object.defineProperty(o, "default", { enumerable: !0, value: t }),
          2 & e && "string" != typeof t)
        )
          for (var n in t)
            i.d(
              o,
              n,
              function (e) {
                return t[e];
              }.bind(null, n)
            );
        return o;
      }),
      (i.n = function (t) {
        var e =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return i.d(e, "a", e), e;
      }),
      (i.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (i.p = "/"),
      i((i.s = 11))
    );
  })({
    0: function (t, e) {
      t.exports = require("jquery");
    },
    1: function (t, e, i) {
      "use strict";
      i.r(e);
      var o = i(0),
        n = i.n(o),
        r = "loadstart",
        u = "loaded",
        a = "ended",
        s = "currentTimeUpdate",
        l = "mute",
        c = "unmute",
        d = "volumeUpdate",
        h = "pause",
        p = "play",
        f = "watcherUpdate",
        y = "destroy",
        v = (function () {
          function t(t) {
            (this.config = {
              src: "",
              autoPlay: !1,
              frequency: 200,
              volume: 0.5,
            }),
              (this.$eventEl = n()("<div />")),
              (this.watcher = 0),
              (this.audio = new Audio()),
              (this.canplay = !1),
              (this.firstTimeLoad = !0),
              (this.config = n.a.extend({}, this.config, t)),
              (this.lastVolume = this.config.volume),
              this.init();
          }
          return (
            (t.prototype.init = function () {
              (this.audio = new Audio()),
                this.event_handler(),
                this.load_audio(this.config.src, this.config.autoPlay);
            }),
            (t.prototype.play = function () {
              this.canplay &&
                this.audio.paused &&
                this.hack_chrome_autoplay_policy();
            }),
            (t.prototype.pause = function (t) {
              void 0 === t && (t = !1),
                ((this.canplay && !this.audio.paused) || t) &&
                  (this.$eventEl.trigger(h, [
                    this.audio.currentTime,
                    this.audio.duration,
                    this.audio,
                  ]),
                  window.clearInterval(this.watcher),
                  this.audio.pause());
            }),
            (t.prototype.toggle_play = function () {
              this.audio.paused ? this.play() : this.pause();
            }),
            (t.prototype.mute = function () {
              (this.lastVolume = this.audio.volume),
                (this.audio.volume = 0),
                this.$eventEl.trigger(l);
            }),
            (t.prototype.unmute = function () {
              this.canplay &&
                ((this.audio.volume =
                  0 === this.lastVolume ? 0.1 : this.lastVolume),
                this.$eventEl.trigger(c, this.audio.volume));
            }),
            (t.prototype.toggle_mute = function () {
              0 === this.audio.volume ? this.unmute() : this.mute();
            }),
            (t.prototype.load_audio = function (t, e) {
              var i = this;
              (this.canplay = !1),
                n()(this.audio).one("canplay", function () {
                  (i.canplay = !0),
                    i.$eventEl.trigger(u, [
                      i.audio.currentTime,
                      i.audio.duration,
                    ]),
                    e && i.hack_chrome_autoplay_policy();
                }),
                (this.audio.src = t),
                this.audio.load();
            }),
            (t.prototype.set_volume = function (t) {
              (this.lastVolume = this.audio.volume),
                (this.audio.volume = t),
                this.$eventEl.trigger(d, [t]);
            }),
            (t.prototype.get_volume = function () {
              return this.audio.volume;
            }),
            (t.prototype.set_current_time = function (t, e) {
              void 0 === e && (e = !1),
                this.canplay &&
                  ((this.audio.currentTime = e
                    ? Math.floor(this.audio.duration * t)
                    : t),
                  this.$eventEl.trigger(s, [
                    this.audio.currentTime,
                    this.calc_percentage(
                      this.audio.currentTime,
                      this.audio.duration
                    ),
                    this.audio,
                  ]));
            }),
            (t.prototype.get_current_time = function () {
              if (this.canplay) return this.audio.currentTime;
            }),
            (t.prototype.get_duration = function () {
              return this.audio.duration;
            }),
            (t.prototype.format_time = function (t) {
              var e = String("00" + Math.floor(t / 3600)).slice(-2) + ":",
                i = String("00" + Math.floor((t % 3600) / 60)).slice(-2) + ":",
                o = String("00" + Math.floor((t % 3600) % 60)).slice(-2);
              return t > 3600 ? e + i + o : i + o;
            }),
            (t.prototype.destroy = function () {
              this.$eventEl.trigger(y),
                window.clearInterval(this.watcher),
                (this.canplay = !1),
                this.$eventEl.remove(),
                (this.audio.src = "");
            }),
            (t.prototype.on = function (t, e) {
              return this.$eventEl.on(t, e), this;
            }),
            (t.prototype.one = function (t, e) {
              return this.$eventEl.one(t, e), this;
            }),
            (t.prototype.off = function (t) {
              return this.$eventEl.off(t), this;
            }),
            (t.prototype.event_handler = function () {
              var t = this;
              n()(this.audio)
                .on("loadstart", function () {
                  t.$eventEl.trigger(r);
                })
                .on("ended", function () {
                  t.$eventEl.trigger(a);
                });
            }),
            (t.prototype.set_watcher_interval = function () {
              var t = this;
              window.clearInterval(this.watcher),
                (this.watcher = window.setInterval(function () {
                  t.$eventEl.trigger(f, [
                    t.audio.currentTime,
                    t.calc_percentage(t.audio.currentTime, t.audio.duration),
                    t.audio.duration,
                    t.audio.ended,
                  ]);
                }, this.config.frequency));
            }),
            (t.prototype.set_default_volume = function () {
              this.firstTimeLoad &&
                (this.set_volume(this.config.volume),
                (this.firstTimeLoad = !1));
            }),
            (t.prototype.calc_percentage = function (t, e) {
              return +(parseInt(t) / parseInt(e)).toFixed(4);
            }),
            (t.prototype.hack_chrome_autoplay_policy = function () {
              var t = this,
                e = this.audio.play();
              void 0 !== e
                ? e
                    .then(function () {
                      t.set_default_volume(),
                        t.$eventEl.trigger(p, [t.audio]),
                        t.set_watcher_interval();
                    })
                    .catch(function (e) {
                      t.pause(!0),
                        console.log(
                          e,
                          "vAudio必须要有用户交互才能自动播放, https://developers.google.com/web/updates/2016/03/play-returns-promise"
                        );
                    })
                : (this.set_default_volume(),
                  this.$eventEl.trigger(p, [this.audio]),
                  this.set_watcher_interval());
            }),
            t
          );
        })();
      e.default = v;
    },
    11: function (t, e, i) {
      t.exports = i(1);
    },
  });
});
